import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Check Icon/Cross" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M22.3309 10.4004L11.1309 21.6004M22.3309 21.6004L11.1309 10.4004L22.3309 21.6004Z", stroke: "#BDBDBD", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
